/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createAction, props } from '@ngrx/store';
import { IAviDataGridState } from './avi-data-grid-store.state';

const AVI_DATA_GRID_STORE_SOURCE = '[Avi Data Grid Store]';

export const saveAviDataGridDisplayedColumnsSelection = createAction(
    `${AVI_DATA_GRID_STORE_SOURCE} Save Avi Data Grid Displayed Columns Selection`,
    props<{ currentGridColumnVisibilityState: IAviDataGridState }>(),
);
